module.exports = {"customize-order":"arrows-four-directions","download":"arrow-down-tray","edit":"pencil","folder":"folder-closed","globe-alt":"globe","import":"arrow-down-in","invisible":"eye-closed","link":"chain","lock":"lock-closed","ok-circle":"circle-check-mark","question-circle":"circle-question-mark","security-scan":"shield","settings":"sliders","suspend":"sleep","unlock":"lock-open","upload":"arrow-up-tray","visible":"eye"}


//////////////////
// WEBPACK FOOTER
// ./components/Button/old-icon-names.json
// module id = 260
// module chunks = 2